// Redux stuff
import { connect } from 'react-redux';
import { addChoice } from '../actions/choicesActions';

// ui
import CourseTable from './CourseTable';

// helpers and globals
import { isScience, isNW, isNWMain, isLanguageBasic, isForeignLang, isInformatics, isNoDMa, isNoSportLangsMain, isNoSportLangsBasic, isNoSportScience, isSportBasic, isSportBasicNW, isSportMain } from '../common/helpers.js';
import { RESTRICTIONS } from '../common/globals.js';

const getGlobalLeftovers = (branchId, allSelectedCourses, selectedCourse, choices, id, options) => {
    const sciencesCount = allSelectedCourses.filter(isScience).length;
    const NWCount = allSelectedCourses.filter(isNW).length;
    const NWMainCount = allSelectedCourses.filter(isNWMain).length;
    const langBasicCount = allSelectedCourses.filter(isLanguageBasic).length;
    const infCount = allSelectedCourses.filter(isInformatics).length;
    const noDMaCount = allSelectedCourses.filter(isNoDMa).length;
    const noSportLangsCountMain = allSelectedCourses.filter(isNoSportLangsMain).length;
    const noSportLangsCountBasic = allSelectedCourses.filter(isNoSportLangsBasic).length;
    const noSportScienceCount = allSelectedCourses.filter(isNoSportScience).length;
    const sportBasicCount = allSelectedCourses.filter(isSportBasic).length;
    const sportBasicNWCount = allSelectedCourses.filter(isSportBasicNW).length;
    const sportMainCount = allSelectedCourses.filter(isSportMain).length;

    switch(branchId) {
        case 'branch-2':
            if (noSportLangsCountMain === 2) {
                if (!isNoSportLangsMain(selectedCourse)) {
                    options = options.filter((o) => !isNoSportLangsMain(o));
                }
            }
            if (noSportLangsCountBasic === 2) {
                if (!isNoSportLangsBasic(selectedCourse)) {
                    options = options.filter((o) => !isNoSportLangsBasic(o));
                }
            }
            if (noSportScienceCount === 2) {
                if (!isNoSportScience(selectedCourse)) {
                    options = options.filter((o) => !isNoSportScience(o));
                }
            }
            if (sportBasicCount === 2) {
                if (!isSportBasic(selectedCourse)) {
                    options = options.filter((o) => !isSportBasic(o));
                }
            }
            if (sportBasicNWCount === 2) {
                if (!isSportBasicNW(selectedCourse)) {
                    options = options.filter((o) => !isSportBasicNW(o));
                }
            }
            if (sportMainCount === 2) {
                if (!isSportMain(selectedCourse)) {
                    options = options.filter((o) => !isSportMain(o));
                }
            }
            if (sciencesCount === 2) {
                if (!isScience(selectedCourse)) {
                    options = options.filter((o) => !isScience(o));
                }
            }
            if (NWCount === 1) {
                if (!isNW(selectedCourse)) {
                    options = options.filter((o) => !isNW(o));
                }
            }
            if (allSelectedCourses.includes('SP')) {
                if (id === 'slot-2-04') {
                    options = options.concat('ge+ek/sk');
                }
            }
            return options;
        case 'branch-1':
            if (noSportLangsCountMain === 2) {
                if (!isNoSportLangsMain(selectedCourse)) {
                    options = options.filter((o) => !isNoSportLangsMain(o));
                }
            }
            if (noSportLangsCountBasic === 2) {
                if (!isNoSportLangsBasic(selectedCourse)) {
                    options = options.filter((o) => !isNoSportLangsBasic(o));
                }
            }
            if (noSportScienceCount === 2) {
                if (!isNoSportScience(selectedCourse)) {
                    options = options.filter((o) => !isNoSportScience(o));
                }
            }
            if (sportBasicCount === 2) {
                if (!isSportBasic(selectedCourse)) {
                    options = options.filter((o) => !isSportBasic(o));
                }
            }
            if (sportMainCount === 2) {
                if (!isSportMain(selectedCourse)) {
                    options = options.filter((o) => !isSportMain(o));
                }
            }
            if (sciencesCount === 3) {
                if (!isScience(selectedCourse)) {
                    options = options.filter((o) => !isScience(o));
                }
            }
            if (NWCount === 2) {
                if (!isNW(selectedCourse)) {
                    options = options.filter((o) => !isNW(o));
                }
            }
            if (infCount === 3) {
                if (!isInformatics(selectedCourse)) {
                    options = options.filter((o) => !isInformatics(o));
                }
            }
            if (NWMainCount === 1) {
                if (!isNWMain(selectedCourse)) {
                    options = options.filter((o) => !isNWMain(o));
                }
                if (id === 'slot-1-05' || id === 'slot-1-06') {
                    options = options.filter((o) => !isNW(o));
                }
            }
            if (allSelectedCourses.includes('E')) {
                if (id === 'slot-1-05' || id === 'slot-1-06') {
                    options = options.filter((o) => !isInformatics(o));
                }
            }
            if (allSelectedCourses.includes('D')) {
                if (id === 'slot-1-05') {
                    options = options.filter((o) => !isLanguageBasic(o));
                }
            }
            if (allSelectedCourses.includes('M')) {
                if (id === 'slot-1-05') {
                    options = options.filter((o) => !isNW(o));
                    options = options.filter((o) => !isForeignLang(o));
                }
            }
            if (isNW(choices['slot-1-05']) && id === 'slot-1-06') {
                options = options.filter((o) => !isNW(o));
                options = options.filter((o) => !isLanguageBasic(o));
            }
            if (isNW(choices['slot-1-06']) && id === 'slot-1-05') {
                options = options.filter((o) => !isNW(o));
                options = options.filter((o) => !isLanguageBasic(o));
            }
            if ((isNoDMa(choices['slot-1-01']) && id === 'slot-1-02') || (isNoDMa(choices['slot-1-02']) && id === 'slot-1-01')) {
                options = options.filter((o) => !isNoDMa(o));
            }
            if (allSelectedCourses.includes('SP')) {
                if (id === 'slot-1-04') {
                    options = options.concat('ge+ek/sk');
                }
            }
            return options;
        default:
            return [];
    }
}


const getSlotLeftovers = (slot, choices, branchId) => {
    const allChoices = choices;
    const allSelectedCourses = Object.values(choices);
    const selectedSlotCourse = choices[slot.id];

    // global restrictions
    const globalRestrictions = allSelectedCourses
        .filter(course => course in RESTRICTIONS)
        .reduce((restrictions, course) => restrictions.concat(RESTRICTIONS[course]), []);

    // options that are left over despite all branch restrictions
    const globalLeftovers = getGlobalLeftovers(branchId, allSelectedCourses, selectedSlotCourse, choices, slot.id, slot.options);

    return globalLeftovers
        // global leftovers that are currently not selected
        .filter((option) => !allSelectedCourses.includes(option))
        // global leftovers that that are neither selected nor globally restricted
        .filter((option) => !globalRestrictions.includes(option));
};

const mapStateToProps = state => {
    const currentBranch = state.branches.find(branch => branch.id === state.currentBranchId);
    const currentSlots = currentBranch.slots.map((slotId) => state.slots.find(slot => slot.id === slotId));
    
    return {
        choices: state.choices,
        // leftovers: 
        currentBranchId: state.currentBranchId,
        slots: currentSlots.map(slot => {
            return {
                id: slot.id,
                choice: state.choices[slot.id],
                leftovers: getSlotLeftovers(slot, state.choices, state.currentBranchId)
            }
        })
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addChoice: (slot, course) => { dispatch(addChoice(slot, course)); }
    };
};

/**
  * Redux container for the CourseTable component
  *
  */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CourseTable);